<template>
    <div class="order-list-box">
        <div v-if="isPc" class="pc-style">
            <div class="back-btn" @click="() => this.$router.push('/profile')"> &lt;返回 </div>
            <div class="has-order" v-if="hasOrder">
                <div class="order-table" v-for="(item, index) in orderInfo" :key="index">
                    <div class="table-header">
                        <div>订单号：{{ item.orderNo }}</div>
                        <div>下单时间：{{ $moment(item.createTime).format('YYYY-MM-DD hh:mm:ss') }}</div>
                    </div>
                    <order-item :item-list="item.hotelOrderDetailsEntities" :isDeleted="item.isDeleted"></order-item>
                    <div class="table-footer">
                        <div class="total-price">合计：<span>¥{{ item.amount }}</span></div>
                        <div  class="img-upload">
                            <div v-if="item.payImg" style="position:relative;width: 110px;height: 110px;margin-top:10px">
                                <img style="width: 110px;height: 110px"  :src="`${showImgUrl}${item.payImg}`" alt="">
                                <div style="position:absolute;left:0;top:0;bottom:0;right:0;background:rgba(0,0,0,0.5);display:flex;align-items: center;
                                justify-content: center;color: #fff;font-size: 26px">
                                    <i class="el-icon-delete" @click="Removebanner(item)"></i>
                                </div>
                            
                            </div>
                            <el-upload
                            v-else
                            class="upload-demo"
                            :action="`${baseUrl}/renren-fast/app/audienceCenter/upload`"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :limit="1"
                            list-type="picture"
                            :data='fileData'
                            :on-exceed="handleExceed"
                            :on-success="(response,file,fileList)=>{ uploadSucess(item,response,file,fileList) }"
                            :file-list="fileList">
                            <el-button size="small" type="primary">上传汇款凭证</el-button>
                             <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                            </el-upload>
                        </div>
                        <div>
                            <div class="status-tag" @click="cancel(item)">
                                {{(cancelStatus || item.isDeleted===1) ? '已取消':'取消订单'}}
                            </div>
                            <div class="status-tag">{{ item.payStatus==0?'已支付':'未支付'}}</div>
                        </div>
                    </div>
                </div>
                <router-link to="/hotel_list">
                  <div class="btn-blue"> 继续预定</div>
                </router-link>
            </div>
            <div v-else class="pcOrder">
                <div class="no-order" >尚未预定酒店</div>
                <router-link to="/hotel_list">
                    <div class="btn-blue"> 立刻预定</div>
                </router-link>
            </div>
            
        </div>
        <div v-else>
            <div class="back-btn" @click="() => this.$router.push('/profile')">&lt;返回</div>
            <div class="has-order" v-if="hasOrder">
                <div class="order-table" v-for="(item, index) in orderInfo" :key="index">
                    <div class="table-header">
                        <div>订单号：{{ item.orderNo }}</div>
                    </div>
                    <div class="table-header">
                        <div>下单时间：{{ $moment(item.createTime).format('YYYY-MM-DD hh:mm:ss') }}</div>
                    </div>
                    <order-item :item-list="item.hotelOrderDetailsEntities"></order-item>
                    <div class="table-footer">
                        <div class="total-price">合计：<span>¥{{ item.amount }}</span></div>
                       
                        <div>
                            <div class="status-tag" @click="cancel(item)">
                                {{(cancelStatus || item.isDeleted===1) ? '已取消':'取消订单'}}
                            </div>
                            <div class="status-tag">{{ item.payStatus==0?'已支付':'未支付'}}</div>
                        </div>
                        
                    </div>
                     <!-- 上传-->
                        <div  class="img-upload">
                            <div v-if="item.payImg" style="position:relative;width: 60px;height: 60px;">
                                <img style="width: 60px;height: 60px"  :src="`${showImgUrl}${item.payImg}`" alt="">
                                <div style="position:absolute;left:0;top:0;bottom:0;right:0;background:rgba(0,0,0,0.5);display:flex;align-items: center;
                                justify-content: center;color: #fff;font-size: 26px">
                                    <i class="el-icon-delete" @click="Removebanner(item)"></i>
                                </div>
                            
                            </div>
                            <el-upload
                            v-else
                            class="upload-demo"
                            :action="`${baseUrl}/renren-fast/app/audienceCenter/upload`"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :limit="1"
                            list-type="picture"
                            :data='fileData'
                            :on-exceed="handleExceed"
                            :on-success="(response,file,fileList)=>{ uploadSucess(item,response,file,fileList) }"
                            :file-list="fileList">
                            <el-button size="small" type="primary">上传汇款凭证</el-button>
                             <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                            </el-upload>
                        </div>
                </div>
            </div>
            <div class="no-order" v-else>尚未预定酒店</div>
            <router-link to="/hotel_list">
                <div class="btn-blue"> {{ hasOrder ? '继续预定' : '立刻预定' }}</div>
            </router-link>
        </div>
        
    </div>
</template>

<script>
    import orderItem from './components/order_item'
    import http from '@/utils/http'
    import apis from '@/utils/apis'
export default {
    name: "orderList",
    components: { orderItem },
    data() {
        return {
            hasOrder: false,
            btnText: '立刻预定',
            bedrooms: [],
            cancelStatus:'',
            orderInfo: {
                orderNo: '000123456789',
                orderTime: '2020-07-24',
                totalMoney: '3600.00',
                status: '已支付',
                itemList: [
                    {
                        name: '南京国际青年会议酒店',
                        room: ' 标准间',
                        size: '整间',
                        date: '2020-08-21至 2020-08-23',
                        price: '800',
                        people: '张晶超1 男'
                    },
                    {
                        name: '南京国际青年会议酒店',
                        room: ' 标准间',
                        size: '整间',
                        date: '2020-08-21至 2020-08-23',
                        price: '800',
                        people: '张晶超2 男'
                    },
                    {
                        name: '南京国际青年会议酒店',
                        room: ' 标准间',
                        size: '整间',
                        date: '2020-08-21至 2020-08-23',
                        price: '400',
                        people: '张晶超3 男'
                    }
                ],
                cancelStatus: false
            },
             fileData: {
                subDir: '/banner',
                // token: getToken()
            },
            fileList: [],
            baseUrl: process.env.VUE_APP_BASEURL,
            imgUrl: process.env.VUE_APP_IMGURL,
            showImgUrl: process.env.VUE_APP_SHOW_IMGURL,
        }
    },
    computed: {
        meetingId() {
            return this.$store.state.meetingId || localStorage.getItem('meetingId')
        },
        isPc() {
          console.log(this.$store.state.isPc)
          return this.$store.state.isPc
        }
    },
    created() {
      this.getOrderList()
    },
    methods: {
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.$alert('删除成功')
        },
        Removebanner(item) {
            item.payImg = ''
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除该凭证，重新上传吗？`);
        },
        uploadSucess(item,response,file,fileList) {
            console.log(111,item,response,file,fileList)
            item.payImg = response.msg
            this.savePayImg(item,response)

        },
        handleExceed(files, fileList) {
            // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            this.$message.warning(`当前限制选择 1 个文件,请先点击图片删除前面不用的`);
        },


        async getRoomList() {
            const res = await http.get(`${apis.getRoomList}${this.currentHotel.id}`)
            console.log('bedrooms', res)
            const list = res.HotelRoomList || [];
            this.bedrooms = list
            // this.getOrderList()
        },
        async getOrderList() {
            const audienceId = localStorage.getItem('audienceId')
            const res = await http.get(`${apis.getOrderList}/${this.meetingId}?audienceId=${audienceId}&type=2`)
            console.log('getOrderList', res)
            if(res.code === 0) {
                if(res.hotelOrder){
                    const orderInfo = res.hotelOrder.hotelOrderVO
                    this.orderInfo = orderInfo
                    console.log('orderInfo', this.orderInfo)
                    this.hasOrder = true
                }else{
                    this.hasOrder = false
                }
            }
           
        },
        async cancel(item) {
            if(item.isDeleted){
              return
            }
            const res = await  http.post(`/renren-fast/app/audienceCenter/update/OrderStatus/${item.id}`)
            if(res.code===0){
                this.$alert('取消订单成功')
                this.cancelStatus = true
            }
        },
        async savePayImg(item,response) {
              console.log(222,response)
            // if(item.isDeleted){
            //   return
            // }
            const res = await  http.post(`/renren-fast/app/audienceCenter/update/payImg/${item.id}?payImg=${response.msg}`)
            console.log('上次支付凭证接口',res)
            if(res.code===0){
                this.$alert('上传成功')
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
.img-upload
    width 100px
    margin-left: 0;
    margin-bottom: 20px;
    /deep/ .upload-demo
                display flex
    /deep/ .el-upload-list__item
                width 0px
                margin-top: -10px;
                margin-left: 10px;
    /deep/ .el-upload-list__item-status-label
                display none 
    /deep/ .el-icon-close
                display block
    /deep/ .el-button--small
                font-size 24px    
    /deep/ .el-upload-list--picture .el-upload-list__item-thumbnail  
           width  50px
           height 50px      
.order-list-box
    padding 24px
.back-btn
    color: #606060
    font-size 27px
.btn-blue
    background-color: #2852a6
    color: #fff
    height 60px
    line-height 60px
    border-radius 10px
    width 242px
    text-align center
    font-size 27px
    margin 60px auto 0px auto
.no-order
    font-size 30px
    color: #000
    text-align center
    margin-top 100px
.order-table
    border: 1px solid #cfcfcf
    box-shadow 0px 0px 5px 2px #cfcfcf
    border-radius 20px
    padding:0px 20px
    margin-top 30px
    .table-header
        font-size 25px
        color: #000
        display flex
        justify-content space-between
        height 60px
        line-height 60px
    .table-footer
        display flex
        justify-content space-between
        height 120px
        line-height 120px
        .total-price
            color: #000
            font-size 27px
            span
                color: #ff4e00
                font-size 31px
        .status-tag
            display inline-block
            margin-left 10px
            color #717171
            font-size 23px
            border-radius 23px
            border 1px solid #dcdcdc
            height 46px
            line-height 46px
            margin-top 16px
            padding 0px 20px
@media screen and (min-width: 800px)
      .img-upload
        margin-left -55px
        margin-top -5px
        margin-bottom 0
      .img-upload  /deep/ .el-upload-list__item
        width: 0;
        padding: 17px 0px 0px 160px;
        height: 120px;
      .img-upload .el-button--small
                padding 10px 20px
                font-size 20px  
      .pc-style
        width 900px
        margin 0 auto
      .pcOrder
        width 900px
        height 300px
        margin 0 auto
        border-radius 15px
        border 1px solid #333
        background #fff
      .no-order
          font-size 32px
          color: #000
          text-align center
          margin-top 50px
      .btn-blue
          background-color: #2852a6
          color: #fff
          height 60px
          line-height 60px
          border-radius 10px
          width 233px
          text-align center
          font-size 27px
          margin 70px auto 0px auto
      .back-btn
          font-size 24px
          margin-bottom 20px
      .order-table
          width 900px
          background #fff
          margin 0 auto;
          border: 1px solid #cfcfcf
          box-shadow 0px 0px 5px 2px #cfcfcf
          border-radius 20px
          padding:0px 20px
          margin-top 30px
          .table-header
              font-size 25px
              color: #000
              display flex
              justify-content space-between
              height 84px
              line-height 84px
          .table-footer
              display flex
              justify-content space-between
              height 140px
              line-height 140px
              .total-price
                  color: #000
                  font-size 27px
                  span
                      color: #ff4e00
                      font-size 31px
              .status-tag
                  display inline-block
                  color #717171
                  font-size 23px
                  border-radius 23px
                  border 1px solid #dcdcdc
                  height 46px
                  line-height 46px
                  margin-top 16px
                  padding 0px 20px

/*line-height 84px*/
</style>
